import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { DiscoveryContainer } from './discoveryContainer/discoveryContainer';
import { SkippableContentHandler } from './skippableContent/skippableContentHandler';
import { discoverySelector } from '../../common/store/selectors/discovery.selector';
import { css } from '../../common/styles/styles.utils';

interface DiscoveryPluginProps {
  playerInstanceUniqueId: string;
  style: any;
}

const DiscoveryPlugin: FunctionComponent<DiscoveryPluginProps> = props => {
  const { playerInstanceUniqueId, style } = props;
  const skippableContent = useSelector(discoverySelector.nextVideo) === 'skippableContent';
  const store = (window as any).monti.dataset.store[playerInstanceUniqueId];
  if (skippableContent) {
    SkippableContentHandler.createInstance(store);
  }
  return (
    <div style={css(style)}>
      <DiscoveryContainer />
    </div>

  );
};

export default DiscoveryPlugin;
